import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { tokens, Button, Tooltip } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { withHighlight } from '../withHighlight';
import { EventsBinding } from './KeyboardShortcutEvents';

const DEFAULT_SPEED = 1;

const StyledButton = styled(Button)`
  // Temporary styles, we'll switch to dropdown as a parat of UX improvements
  ${tokens.text('subtitle3')};
  color: ${tokens.color.text_default};
  font-weight: bold;
  border-radius: ${tokens.radius.m};
  height: 24px;
  min-height: 24px;
  width: 41px;
  justify-content: center;
  text-align: center;
  border: 1px solid ${tokens.color.neutral_300};
  ${({ currentSpeed }) => `font-weight: ${currentSpeed !== DEFAULT_SPEED ? 'bold' : 'normal'};`};

  &:focus,
  &:focus-visible {
    border: none;
  }
`;

const SpeedBtn = ({ onClick, currentSpeed = DEFAULT_SPEED, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <Tooltip text={t('common:player.toggle-speed')} isDisabled={disabled}>
      <StyledButton kind="ghost" disabled={disabled} onClick={onClick} currentSpeed={currentSpeed}>
        {currentSpeed}x
      </StyledButton>
    </Tooltip>
  );
};

SpeedBtn.defaultProps = {
  onClick: undefined,
  disabled: false,
};

SpeedBtn.propTypes = {
  onClick: PropTypes.func,
  currentSpeed: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
};

export const SpeedButton = withHighlight(memo(SpeedBtn), EventsBinding.PLAYBACK_SPEED);
